import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AlertService } from './alerts/alert.service';
import { ConfigurationService } from './configuration/configuration.service';
import { ErrorHandlingService } from './error-handling/error-handling.service';
import { HttpService } from './http-service/http.service';
import { ConsoleWriter } from './logging/console.writter';
import { LoggingService } from './logging/logging.service';
import { AuthInterceptor } from './authentication/auth.interceptor';
import { DisableIfUnauthorizedDirective } from './authorization/disable-if-unauthorized.directive';
import { CanHideIfUnauthorizedDirective } from './authorization/hide-if-unauthorized.directive';

export function initializeApp(appConfig: ConfigurationService) {
  const promise = appConfig.load().then((config) => {
  });
  return () => promise;
}

/**
 * The factory function to initialize the logging service and writer for the
 * application.
 *
 * @param loggingService
 * @param consoleWriter
 */
export function initializeLogWriter(loggingService: LoggingService, consoleWriter: ConsoleWriter) {
  // console.log(`Initializing [Console Writer] from [Crosscutting Module]`);
  return () => {
    return consoleWriter;
  }
}

@NgModule({
  declarations: [DisableIfUnauthorizedDirective, CanHideIfUnauthorizedDirective],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [DisableIfUnauthorizedDirective, CanHideIfUnauthorizedDirective],
  providers: [
    HttpClientModule,
    ConfigurationService,
    LoggingService,
    ErrorHandlingService,
    AuthInterceptor,
    { provide: ErrorHandler, useClass: ErrorHandlingService },
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [ConfigurationService], multi: true },
    { provide: APP_INITIALIZER, useFactory: initializeLogWriter, deps: [LoggingService, ConsoleWriter], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    
    ConsoleWriter,
    AlertService,
    HttpService,

  ],

})
export class CrossCuttingModule { }
